import React from 'react';
import { Pressable } from 'react-native';

import ChevronRight from '@/assets/icons/chevronRightCasino';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { isWeb } from '@/utils/constants-platform-specific';

import { LayoutHeaderProps, useLayoutHeaderLink } from '../../hooks/use-layout-header-link';

export const LayoutHeader = (props: LayoutHeaderProps) => {
    const { title } = props;
    const { isNavigable, navigate } = useLayoutHeaderLink(props);

    if (!title) {
        return null;
    }

    return (
        <Pressable onPress={navigate} disabled={!isNavigable} accessibilityRole={isNavigable ? 'button' : undefined}>
            <Box px={isWeb ? 's0' : 's16'} pb="s16" pt="s16">
                <Row alignItems="center">
                    <Text
                        color={ds.colorToken.text.primary}
                        variant="headlineSmall"
                        fontWeight="bold"
                        letterSpacing={-0.45 / 20}
                    >
                        {title}
                    </Text>
                    {isNavigable ? <ChevronRight color={ds.colorValue.icon.primary} height={22} /> : null}
                </Row>
            </Box>
        </Pressable>
    );
};
